import { AmazingTimePickerModule } from 'amazing-time-picker';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { DialogeboxesComponent } from './dialogeboxes/dialogeboxes.component';
import { MatDividerModule } from '@angular/material/divider';
// import {
//     MatButtonModule,
//     MatChipsModule,
//     MatIconModule,
//     MatFormFieldModule,
//     MatInputModule,
//     MatPaginatorModule,
//     MatRippleModule,
//     MatSelectModule,
//     MatSortModule,
//     MatTableModule,
//     MatTabsModule,
//     MatSlideToggleModule,
//     MatToolbarModule,
//     MatDatepickerModule,
//     MatTooltipModule,
//     MatRadioModule,
//     MatStepperModule,
//     MatExpansionModule,
//     MatAutocompleteModule,
//     MatListModule,
//     MatCheckboxModule,
//     MatDialogModule,
//     MatProgressBarModule,
//     MatNativeDateModule,
//     MatMenuModule,
//     MatTreeModule
// } from '@angular/material';

import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatRippleModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatRadioModule } from '@angular/material/radio';
import { MatStepperModule } from '@angular/material/stepper';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatListModule } from '@angular/material/list';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatNativeDateModule } from '@angular/material/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatTreeModule } from '@angular/material/tree';



import { Angular2UsefulSwiperModule } from 'angular2-useful-swiper';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { UserModalComponent } from './user-modal/user-modal.component';
import { ConfirmModalComponent } from './confirm-modal/confirm-modal.component';
import { NumbersOnlyDirective } from './directives/number-only/numbers-only.directive';

import { FilterPipe } from './pipes/filter.pipe';
import { PerfectScrollbarModule, PERFECT_SCROLLBAR_CONFIG, PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { AttachedModalComponent } from './attached-modal/attached-modal.component';
import { RouterModule } from '@angular/router';
import { MeetingModalComponent } from 'src/app/meetings/meeting-modal/meeting-modal.component';
import { InterModalComponent } from 'src/app/interOffice/inter-modal/inter-modal.component';
import { TruncatePipe } from './pipes/truncate.pipe';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
    suppressScrollX: true
};
@NgModule({
    imports: [
        FormsModule,
        CommonModule,
        MatButtonModule,
        MatChipsModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatPaginatorModule,
        MatRippleModule,
        MatSelectModule,
        MatSortModule,
        MatTableModule,
        MatTabsModule,
        MatSlideToggleModule,
        MatToolbarModule,
        MatDatepickerModule,
        MatTooltipModule,
        MatStepperModule,
        MatExpansionModule,
        MatAutocompleteModule,
        MatListModule,
        MatCheckboxModule,
        MatDialogModule,
        MatProgressBarModule,
        MatRadioModule,
        ReactiveFormsModule,
        MatNativeDateModule,
        MatMenuModule,
        CdkStepperModule,
        MatTreeModule,
        AmazingTimePickerModule,
        Angular2UsefulSwiperModule,
        Ng2SearchPipeModule,
        PerfectScrollbarModule,
        RouterModule,
        MatDividerModule
    ],
    exports: [
      FormsModule,
      CommonModule,
      MatButtonModule,
      MatChipsModule,
      MatFormFieldModule,
      MatIconModule,
      MatInputModule,
      MatPaginatorModule,
      MatRippleModule,
      MatSelectModule,
      MatSortModule,
      MatTableModule,
      MatTabsModule,
      MatSlideToggleModule,
      MatToolbarModule,
      MatDatepickerModule,
      MatTooltipModule,
      MatStepperModule,
      MatExpansionModule,
      MatAutocompleteModule,
      MatListModule,
      MatCheckboxModule,
      MatDialogModule,
      MatProgressBarModule,
      MatRadioModule,
      ReactiveFormsModule,
      MatNativeDateModule,
      MatMenuModule,
      CdkStepperModule,
      MatTreeModule,
      AmazingTimePickerModule,
      Angular2UsefulSwiperModule,
      Ng2SearchPipeModule,
      PerfectScrollbarModule,
      RouterModule,
      MeetingModalComponent,
      InterModalComponent,
      MatDividerModule,
      TruncatePipe
    ],
    declarations: [UserModalComponent, ConfirmModalComponent, AttachedModalComponent, NumbersOnlyDirective,  FilterPipe, TruncatePipe,DialogeboxesComponent,MeetingModalComponent,InterModalComponent],
    providers: [{
        provide: PERFECT_SCROLLBAR_CONFIG,
        useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    }]
})
export class SharedModule {
}



